<header class="pb-3" *ngIf="model && model.title!='Dashboard'">
    <div class="pb-2">
        <h1 class="fs-2 fw-light text-gray-600">{{model.title}}</h1>
    </div>
    <div class="breadcrumbs d-flex">
        <div class="me-2">
            <a [routerLink]="['']" class="btn-link">
                <i class="fas fa-home"></i>
            </a>
        </div>
        <ng-container *ngIf="model.breadcrumbs">
            <div class="me-2" *ngFor="let bc of model.breadcrumbs">
                / <a [routerLink]="bc.url" class="btn-link">
                    <span>{{bc.title}}</span>
                </a>
            </div>
        </ng-container>
        <div class="me-2">
            / <span *ngIf="model.title">{{model.title}}</span>
        </div>
    </div>
</header>
